import React from "react";
import { FUNNEL_STEPS, pct } from "./format";

/* Horizontal funnel: Issued → Scanned → Claimed → Reserved → Redeemed. */
export const FunnelBars = ({ stats, compact = false, testid = "funnel" }) => {
  const base = Math.max(stats?.live || 0, 1);
  return (
    <div className={compact ? "space-y-1" : "space-y-2"} data-testid={testid}>
      {FUNNEL_STEPS.map(([key, label]) => {
        const n = stats?.[key] || 0;
        const w = Math.max(2, Math.round((n / base) * 100));
        return (
          <div key={key} className="flex items-center gap-3 text-xs" data-testid={`${testid}-${key}`}>
            <span className={`text-slate-400 ${compact ? "w-16" : "w-20"} shrink-0`}>{label}</span>
            <div className="flex-1 h-2.5 rounded-full bg-white/5 overflow-hidden">
              <div className="h-full rounded-full bg-gradient-to-r from-amber-500 to-amber-300 transition-[width] duration-500" style={{ width: `${w}%` }} />
            </div>
            <span className="w-24 text-right text-slate-200 tabular-nums shrink-0">
              <b>{n}</b>{key !== "live" && <span className="text-slate-500"> · {pct((n / base) * 100)}</span>}
            </span>
          </div>
        );
      })}
    </div>
  );
};
